import { __assign } from "tslib";
export var helpcenterContactApiRelativePath = "/helpcenter/contact";
export var createHelpcenterContactApi = function (baseUrl, http) {
    var apiUrl = "" + baseUrl + helpcenterContactApiRelativePath;
    return {
        getContactSettings: function (dto) {
            return http.get(apiUrl + "/" + dto.locale + (dto.brandId ? "?brandId=" + dto.brandId : ''));
        },
        updateContactSettings: function (dto) {
            return http.put(apiUrl + "/" + dto.locale, dto.brandId ? __assign(__assign({}, dto.data), { brandId: dto.brandId }) : dto.data);
        }
    };
};
//# sourceMappingURL=index.js.map